import { makeStyles, tokens } from '@fluentui/react-components';
export var useCarouselAccordionHeaderStyles = makeStyles({
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        lineHeight: tokens.lineHeightBase600,
        marginBottom: '1rem',
        userSelect: 'none',
        ':disabled': {
            color: tokens.colorNeutralForegroundDisabled,
        },
    },
    navContainer: {
        display: 'flex',
        alignItems: 'end',
        justifyContent: 'end',
        width: '2rem',
    },
    pageTitle: {
        fontSize: tokens.fontSizeBase500, // 20px
    },
    subTitleTwo: {
        fontSize: tokens.fontSizeBase400, // Subtitle 2 - 16px
    },
    titleBase: {
        color: tokens.colorNeutralForeground1,
        fontFamily: tokens.fontFamilyBase,
        fontWeight: tokens.fontWeightSemibold,
    },
});
//# sourceMappingURL=CarouselHeaderAccordion.style.js.map